import { useEffect } from 'react';
import { useQueries } from '@tanstack/react-query';

import { Project } from '../types';

import { getProjectRole } from '../apis/ProjectApi';
import { useAppDispatch } from '../hooks';
import { setProjectsExceptViewer } from '../slices/projectSlice';

export const useProjectsExceptViewer = (projects: Project[]) => {
  const dispatch = useAppDispatch();

  const results = useQueries({
    queries: projects.map((project) => ({
      queryKey: ['project-role', project.id, project.ownerId],
      queryFn: () => getProjectRole(project.id).then((res) => res.data),
      enabled: !!project.id,
      refetchOnWindowFocus: false,
    })),
  });

  useEffect(() => {
    const projectsExceptViewer: Project[] = projects.reduce(
      (acc, project, idx) => {
        const roleObj = results[idx]?.data;
        if (roleObj?.data && roleObj.data !== 'viewer') {
          acc.push(project);
        }
        return acc;
      },
      [] as Project[],
    );

    dispatch(setProjectsExceptViewer({ projectsExceptViewer }));
  }, [results, projects, dispatch]);
};
